import React from 'react';
import { TabsTimelineSub } from 'components';
import { tabs } from './tabs';
import { useSelector } from 'react-redux';

const EvaluationFormBeneficiary = (disabledBeneficiaryTabs) => {
    const currentSubTab = useSelector(state => state.forms.carrier.currentSubTab) || 0;
    const isDisabledTabs = disabledBeneficiaryTabs?.disabled;
    return (
        <TabsTimelineSub
            tabs={tabs(isDisabledTabs)}
            // current={'0'} 
            // setCurrent={'0'} 
            currentSubTab={currentSubTab}
            customClass={'custom-tabs-timeline-sub'}
        />
    )
}

export default EvaluationFormBeneficiary;
